import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';
import FieldButton from './FieldButton';
import { isLoadingCustomerInfo, loadCustomerInfoRequest } from '../../../../features/customerInfo';
import { Span, LinkStyled } from '../../../../components/typography';
import { validateFieldRequest } from '../../../../features/form-error/actions';
import { getErrorIfShow } from '../../../../features/form-error/selectors';
import { AiFillMinusCircle, ImSpinner } from '../../../../components/Icons';

const RemoveLinkWrap = styled.div`
  display: inline-block;
  position: relative;
  width: 32px;
  top: 6px;
`;
const RemoveLink = styled(LinkStyled)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;

  svg {
    font-size: 20px;
    fill: ${({ theme }) => theme.colors.colorRed};

    &:hover {
      fill: ${({ theme }) => theme.hoverColors.colorRed};
    }
  }
`;

const GridWrap = styled.div`
  display: grid;
  margin-top: 10px;
  grid-template-columns: ${({ tlf, by, postnr }) => (tlf ? '40px minmax(0, 1fr) 70px' : by ? 'minmax(0, 1fr)' : postnr ? '40px 90px' : '40px minmax(0, 1fr)')};
`;

const TeaxtareaNoProps = ({
  error,
  ...props
}) => <textarea {...props} />;
const basicStyles = ({ theme, error }) => `
  outline: none;
  border: 2px solid ${theme.colors.colorGreyLightAlt};
  padding: 14px;
  position: relative;
  font-size: 14px;
  ${error && `border-color: ${theme.colors.colorRed};`}
`;
const Textarea = styled(TeaxtareaNoProps)`
  ${basicStyles};
  margin-top: 10px;
  min-height: 35px;
  resize: none;
  width: calc(100% - 32px);

  @media (max-width: 991px) {
    min-height: 55px;
    font-size: 16px;
    padding: 12px;
    width: calc(100% - 28px);
  }
`;
const InputNoStyle = ({
  required,
  ...otherProps
}) => <input {...otherProps} />;

const Input = styled(InputNoStyle)`
  ${basicStyles}
  height: auto;

  @media (max-width: 991px) {
    font-size: 16px;
    padding: 12px;
  }
  ${({ required }) => {
    if (required) {
      return `
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAP1BMVEX/////////////////////AAD/AQL/BQX/Cwv/ERH/GRn/KCj/KSn/eHj/jo7/pab/s7P/7+//+Pj/+/v///+rGNLQAAAABXRSTlPe7u/1/lN+rPwAAABmSURBVEjH7dZJDoAwCAVQqtKJ2pH7n9UrFIxxA/uXfIYFAE5acLK0gOXkkBNnxIiR14RIRiZzzsxzn7RQVymrhrZNekRKiTD2/WDj9oj+HvwlUQRTtK8YsmaVdvxGjPxIFG/PJSYP4d250ecFN0IAAAAASUVORK5CYII=);
        background-repeat: no-repeat;
        background-size: 30px;
        background-position: right top;
      `;
    }
    return '';
  }}
`;

const IconSpinner = styled(ImSpinner)`
  animation: spin 1s linear infinite;
  font-size: 20px;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const FieldButtonComponent = ({
  isLoading,
  children,
  onClick,
}) => (
  <FieldButton onClick={onClick} HentInfo>
    {isLoading ? <IconSpinner /> : children }
  </FieldButton>
);
const ConnectedFieldButtonComponent = connect(
  state => ({
    isLoading: isLoadingCustomerInfo(state),
  }),
  {
    onClick: loadCustomerInfoRequest,
  },
)(FieldButtonComponent);

export const FieldComponent = ({
  required,
  by,
  textarea,
  tlf,
  postnr,
  placeholder,
  onChange,
  icon,
  name,
  comment,
  error,
  onRemove,
  ...input
}) => {
  if (textarea) {
    return (
      <Textarea
        onChange={onChange}
        placeholder={placeholder}
        name={name}
        error={error}
        {...input}
      />
    );
  }
  let Container = 'div';
  if (by || postnr) {
    Container = React.Fragment;
  }
  return (
    <Container>
      <GridWrap
        tlf={tlf}
        by={by}
        postnr={postnr}
      >
        {icon}
        <Input
          required={required}
          placeholder={placeholder}
          name={name}
          error={error}
          onChange={onChange}
          onRemove={onRemove}
          {...input}
        />
        {tlf && (<ConnectedFieldButtonComponent>Hent fra Krak</ConnectedFieldButtonComponent>)}
      </GridWrap>
      {comment && (
        <React.Fragment>
          <Span fontSize="12px" block relative top="2px">{comment}</Span>
        </React.Fragment>
      )}
      {onRemove && (
        <RemoveLinkWrap>
          <RemoveLink action noStyle onClick={onRemove}>
            <AiFillMinusCircle />
          </RemoveLink>
        </RemoveLinkWrap>
      )}
    </Container>
  );
};

export default connect(
  (state, { formKey: form, name: field }) => ({
    error: getErrorIfShow(state, { container: 'forms', form, field }),
  }),
  (dispatch, { formKey: form, name: field, onChange }) => ({
    onChange: (...args) => {
      setTimeout(
        () => dispatch(validateFieldRequest({ container: 'forms', form, field })),
        0,
      );
      onChange(...args);
    },
  }),
)(FieldComponent);
